import React, { ErrorInfo } from 'react';
import postError from './api/error';
import { RETAIL_CONTACT_MESSAGE } from './utils/config';

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    postError({ error: `${error.message}, STACK\n${error.stack}` });
    this.setState({ hasError: true });
  }

  render() {
    const { hasError } = this.state;

    if (hasError) {
      return (
        <div style={{ margin: '20px', padding: '20px' }}>
          <h3>Something went wrong. Our team has been notified.</h3>
          <p>{RETAIL_CONTACT_MESSAGE}</p>
        </div>
      );
    }

    const { children } = this.props;
    return children;
  }
}

export default ErrorBoundary;
